import { render, staticRenderFns } from "./SortableTableHeader.vue?vue&type=template&id=2b936306&scoped=true&"
import script from "./SortableTableHeader.vue?vue&type=script&lang=js&"
export * from "./SortableTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./SortableTableHeader.vue?vue&type=style&index=0&id=2b936306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b936306",
  null
  
)

export default component.exports